import { makeStyles } from '@material-ui/core/styles';
import { UseToastQueue } from '#root/hooks/useToastQueue';
import Toast from './Toast';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'fixed',
    zIndex: theme.zIndex.snackbar,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    pointerEvents: 'none',

    '& > *': {
      pointerEvents: 'auto',
    },

    // Mobile override: SIEMPRE top-center con 90vw en pantallas < 600px
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(2),
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translateX(-50%)',
      width: '86vw',
      alignItems: 'center',
    },
  },

  // Posiciones (solo desktop)
  'top-left': {
    top: theme.spacing(3),
    left: theme.spacing(3),
  },
  'top-center': {
    top: theme.spacing(3),
    left: '50%',
    transform: 'translateX(-50%)',
  },
  'top-right': {
    top: theme.spacing(3),
    right: theme.spacing(3),
  },
  'bottom-left': {
    bottom: theme.spacing(3),
    left: theme.spacing(3),
  },
  'bottom-center': {
    bottom: theme.spacing(3),
    left: '50%',
    transform: 'translateX(-50%)',
  },
  'bottom-right': {
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
}));

interface ToastContainerProps {
  queue: UseToastQueue;
  showProgress?: boolean;
}

const ToastContainer = (props: ToastContainerProps) => {
  const { queue, showProgress = false } = props;
  const classes = useStyles();

  const { toasts, removeToast, pauseToast, resumeToast, position } = queue;

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className={`${classes.container} ${classes[position]}`}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={removeToast}
          onPause={pauseToast}
          onResume={resumeToast}
          showProgress={showProgress}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
